// extracted by mini-css-extract-plugin
export var ignore = "_6v-1";
export var mapping = "_6v-0";
export var range = "_6v-4";
export var savings = "_6v-3";
export var settings = "_6v-2";